const characteristicUrl = 'https://unbound-legends.imgix.net/character2/charstat-kf.svg?auto=format';

export const Brawn = characteristicUrl;
export const Agility = characteristicUrl;
export const Intellect = characteristicUrl;
export const Cunning = characteristicUrl;
export const Willpower = characteristicUrl;
export const Presence = characteristicUrl;

const doubleValueUrl = 'https://unbound-legends.imgix.net/character2/statblock02-kf.svg?auto=format';

export const Wounds = doubleValueUrl;
export const Strain = doubleValueUrl;
export const Defense = doubleValueUrl;

export const Soak = 'https://unbound-legends.imgix.net/character2/statblock01-kf.svg?auto=format';
export const Logo = 'https://ul-emporium.imgix.net/logos/keyforge-logo-bigger.png';
export const AvailableXp = 'https://ul-emporium.imgix.net/attributes/emp-kf-avaxp.svg';
export const TotalXp = 'https://ul-emporium.imgix.net/attributes/emp-kf-totxp.svg';
export const StrainThreshold = Soak;
export const WoundsThreshold = Soak;

export const VehicleStatBlock = '/assets/images/KF/kf-vehicle-statblocks.svg';

export { default as background } from './background.png';
